import {Environnement} from 'capcod-api';

export const environment: Environnement = {
  production: false,
  applicationName: 'workflow',
  applicationId: '08da38d4-f292-4471-8f9b-c2d8553f87ce',
  ssoUrl: 'https://sso.operations.cci.fr',
  envName: 'test',
  apiUrl: 'https://api.operations.cci.fr/workflow/api',
  table: {
    useAdvancedFilters: true
  },
  sdkConfigs: [
    { apiName: 'jarvis', url:'https://api.operations.cci.fr/jarvis/api' },
    { apiName: 'workflow', url:'https://api.operations.cci.fr/workflow/api' },
  ],
};
